import { FormField } from 'components/shared/form';
import { RentRollTableColumn, ResidentialRentRollUnit } from 'types/underwriting/income-approach';
import { RENT_ROLL_LABELS } from '../../constants';
import Form from 'mobx-react-form';
import { INCOME_APPROACH_BASIS_TYPES, IncomeApproachBasisType } from 'shared/calculations/incomeApproach';

export const rentRollFormFields: FormField[] = [
  {
    name: 'incomeApproach',
    fields: [
      {
        name: 'residential',
        fields: [
          {
            name: 'rentRoll',
            type: 'array',
            value: [],
          },
          {
            name: 'rentRoll[]',
            fields: [
              {
                name: 'number',
                type: 'text',
                value: '',
              },
              {
                name: 'bedrooms',
                type: 'number',
                value: 0,
              },
              {
                name: 'bathrooms',
                type: 'number',
                value: 0,
              },
              {
                name: 'squareFootage',
                type: 'number',
                value: 0,
              },
              {
                name: 'rent',
                type: 'number',
                value: 0,
              },
              {
                name: 'projectedRent',
                type: 'number',
                value: 0,
              },
              {
                name: 'outdoor',
                type: 'text',
                value: '',
              },
              {
                name: 'rentType',
                type: 'text',
                value: '',
              },
              {
                name: 'unitLayout',
                type: 'text',
                value: '',
              },
              {
                name: 'leaseStatus',
                type: 'text',
                value: '',
              },
            ],
          },
          {
            name: 'vcLossPercentage',
            type: 'number',
            value: 0,
          },
        ],
      },
    ],
  },
];

export const rentRollFormHelpers = {
  getUnitsTableColumns(isProjectedRentRoll: boolean = false): RentRollTableColumn[] {
    const columns: RentRollTableColumn[] = [
      {
        data: 'index',
        value: '#',
      },
      {
        data: 'number',
        value: RENT_ROLL_LABELS.UNIT_NUMBER,
      },
      {
        data: 'bedrooms',
        value: RENT_ROLL_LABELS.BEDROOMS,
      },
      {
        data: 'bathrooms',
        value: RENT_ROLL_LABELS.BATHROOMS,
      },
      {
        data: 'squareFootage',
        value: RENT_ROLL_LABELS.SQUARE_FOOTAGE,
      },
      {
        data: 'rent',
        value: RENT_ROLL_LABELS.BORROWER_MONTHLY_RENT,
      },
    ];

    if (isProjectedRentRoll) {
      columns.push({
        data: 'projectedRent',
        value: RENT_ROLL_LABELS.PROJECTED_MONTHLY_RENT,
      });
    }
    columns.push(
      ...[
        {
          data: 'rentPerSF',
          value: `${isProjectedRentRoll ? 'Projected' : ''} ${RENT_ROLL_LABELS.RENT_PER_SF}`,
        },
        {
          data: 'rentType',
          value: RENT_ROLL_LABELS.RENT_TYPE,
        },
        {
          data: 'leaseStatus',
          value: RENT_ROLL_LABELS.LEASE_STATUS,
        },
        {
          data: 'unitLayout',
          value: RENT_ROLL_LABELS.UNIT_LAYOUT,
        },
        {
          data: 'outdoor',
          value: RENT_ROLL_LABELS.OUTDOOR_SPACE,
        },
      ]
    );

    return columns;
  },
  getResidentialIncomeTotal(form: Form, type: IncomeApproachBasisType) {
    const rentRollField = form.$('incomeApproach.residential.rentRoll') || [];
    const rentRoll = rentRollField.value;
    const rentField = type === INCOME_APPROACH_BASIS_TYPES.borrower ? 'rent' : 'projectedRent';
    const total = rentRoll.reduce((sum: any, unit: ResidentialRentRollUnit) => sum + (unit[rentField] || 0), 0);
    return total * 12;
  },
};
